import * as actions from '../../redux/actions';

import React, { useState } from 'react';

import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import IvergramaTitle from '../common/IvergramaTitle';
import KuposHelmet from '../../../common/KuposHelmet';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const IvergramaTnCScreen = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;

	let data = [];
	if (operator && operator.operator_name === 'aeroquinta' && operator.terms) {
		const sections = operator.terms.split('<strong>').slice(1);

		data = sections.map((section, index) => {
			let heading = section.split('</strong>')[0].trim();
			// heading = heading.replace(/^\w+\.\s*/, '');

			let content = section.split('</strong>')[1].trim();
			content = content.replace(/\{C\}<\!--[^>]*-->/g, '');

			return {
				id: index + 1,
				heading: heading,
				content: content,
				isOpen: false,
			};
		});
	} else {
		data = [
			{
				id: 1,
				heading: 'Términos y condiciones',
				content: operator && operator.terms ? operator.terms : '',
				isOpen: false,
			},
			{
				id: 2,
				heading: 'Políticas de privacidad',
				content: operator && operator.privacy_policy ? operator.privacy_policy : '',
				isOpen: false,
			},
		];
	}

	const [accordionData, setAccordionData] = useState(data);

	const toggleAccordion = id => {
		setAccordionData(prevAccordionData =>
			prevAccordionData.map(accordion => ({
				...accordion,
				isOpen: accordion.id === id ? !accordion.isOpen : accordion.isOpen,
			})),
		);
	};

	return (
		<div className="">
			<KuposHelmet />
			<HeroSection
				title="Términos y condiciones"
				height={'45vh'}
				description="Home / Términos y condiciones        "
				heroImage={getIcons('tncBanner', operator)}
			/>

			<IvergramaTitle operator={operator} title="Términos y condiciones" />

			<div className="new-container  mb10 mt10">
				{accordionData.map((accordion, index) => (
					<div key={accordion.id} style={{ marginBottom: '10px' }}>
						<span
							onClick={() => toggleAccordion(accordion.id)}
							className="accordion-toggle"
							style={{
								color: 'rgb(1, 82, 166)',
								color: `${operator && operator.operator_name === 'aeroquinta' || operator && operator.operator_name === 'basetorres' ? "" : "rgb(1, 82, 166)"}`,
								display: 'flex',
								alignItems: 'center',
								padding: '12px',
								borderRadius: '5px',
								boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
							}}
						>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									color: `${operator && operator.operator_name === 'aeroquinta' || operator && operator.operator_name === 'basetorres' ? "" : "rgb(1, 82, 166)"}`,
									fontSize: '20px',
									fontWeight: `${operator && operator.operator_name === 'aeroquinta' ? "500" : "bolder"}`,
								}}
							>
								<p style={{ marginBottom: '5px' }}>{index + 1}.</p>
								<p
									style={{ marginBottom: '5px', marginLeft: '10px' }}
									dangerouslySetInnerHTML={{ __html: accordion.heading }}
								/>
							</div>

							<div style={{ marginLeft: '10px' }}>
								{accordion.isOpen ? (
									<img
										alt="white-arrow"
										src={getIcons('tncDownArrow', operator)}
										style={{ width: '20px', transform: 'rotate(180deg)', marginBottom: '5px' }}
									/>
								) : (
									<img
										alt="white-arrow"
										src={getIcons('tncDownArrow', operator)}
										style={{ width: '20px', marginBottom: '5px' }}
									/>
								)}
							</div>
						</span>
						{accordion.isOpen && (
							<div
								dangerouslySetInnerHTML={{ __html: accordion.content }}
								className="justify-text"
								style={{ fontSize: '14px', marginTop: '20px', lineHeight: '18.2px' }}
							/>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(IvergramaTnCScreen);


// WEBPACK FOOTER //
// ./src/features/themes/Ivergrama/IvergramaPages/IvergramaTnCScreen.js